import { BREAKPOINTS, Colors, FlexBox } from "@brg/ui";
import { FC } from "react";
import styled from "styled-components";
import tinycolor from "tinycolor2";

const Wrapper = styled(FlexBox)`
    width: 100%;
    padding: 48px 90px 48px 48px;
    font-size: 42px;
    line-height: 48px;
    background-color: ${Colors.geoWhite100};
    color: ${Colors.galBlack100};

    @media(max-width: ${BREAKPOINTS.DESKTOP_SMALL_MAX}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

enum BRS_VALUES {
    white = 255,
    lessWhite = 215,
    normal = 110,
    dark = 60
}
  

export const NominationName: FC<{ color: string, name: string}> = ({ name, color}) => {

    return (
        <Wrapper>{name}</Wrapper>
    )
}import { BREAKPOINTS, Colors, FlexBox } from "@brg/ui";
import { FC } from "react";
import styled from "styled-components";
import tinycolor from "tinycolor2";

const Wrapper = styled(FlexBox)`
    width: 100%;
    padding: 48px 90px 48px 48px;
    font-size: 42px;
    line-height: 48px;
    background-color: ${Colors.geoWhite100};
    color: ${Colors.galBlack100};

    @media(max-width: ${BREAKPOINTS.DESKTOP_SMALL_MAX}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

enum BRS_VALUES {
    white = 255,
    lessWhite = 215,
    normal = 110,
    dark = 60
}
  

export const NominationName: FC<{ color: string, name: string}> = ({ name, color}) => {

    return (
        <Wrapper>{name}</Wrapper>
    )
}